<template>
  <nav class="navbar">
    <div class="navbar-center-box">
      <div class="navbar-content">
        <img src="@/assets/logo1.png" alt="Logo" class="nav-logo-img" />
        <ul class="nav-menu">
          <li>
            <router-link to="/" exact-active-class="active">Home</router-link>
          </li>
          <li>
            <router-link to="/vaults" active-class="active"
              >Strategy Vaults</router-link
            >
          </li>
          <li>
            <router-link to="/blogs" active-class="active">Blog</router-link>
          </li>
          <li>
            <router-link to="/reports" active-class="active"
              >Reports</router-link
            >
          </li>
          <li>
            <router-link to="/about-us" active-class="active"
              >About us</router-link
            >
          </li>
        </ul>

        <div class="navbar-actions desktop-actions">
          <slot name="actions"></slot>
        </div>

        <!-- 新增：右侧容器，移动端显示 -->
        <div class="navbar-right">
          <div class="mobile-actions">
            <slot name="actions"></slot>
          </div>
          <button class="nav-hamburger" @click="showDrawer = true">
            <span class="hamburger-icon"></span>
          </button>
        </div>
      </div>
    </div>
    <!-- 新增：移动端抽屉菜单 -->
    <transition name="drawer-fade">
      <div class="nav-drawer" v-if="showDrawer">
        <div class="drawer-top-panel">
          <div class="drawer-header">
            <div class="nav-logo-placeholder"></div>
            <span class="drawer-close" @click="showDrawer = false"
              >&times;</span
            >
          </div>
          <ul class="drawer-menu">
            <li
              v-for="item in navItems"
              :key="item.path"
              @click="showDrawer = false"
            >
              <router-link :to="item.path" active-class="active">{{
                item.name
              }}</router-link>
            </li>
          </ul>
        </div>
        <!-- 遮罩层，点击关闭 -->
        <div class="drawer-mask" @click="showDrawer = false"></div>
      </div>
    </transition>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
// ...你原有的代码...
const showDrawer = ref(false);

// 判断是否移动端（700px以下）
const isMobile = ref(false);
function handleResize() {
  isMobile.value = window.innerWidth <= 700;
}
onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

// 菜单项（如原有已定义可复用）
const navItems = [
  { name: "Home", path: "/" },
  { name: "Strategy Vaults", path: "/vaults" },
  { name: "Blog", path: "/blogs" },
  { name: "Reports", path: "/reports" },
  { name: "About us", path: "/about-us" },
];
</script>

<style scoped>
.navbar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 0;
  border-radius: 0;
  position: sticky;
  top: 0;
  z-index: 100;
}
.navbar-center-box {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.navbar-content {
  display: flex;
  align-items: center;
  padding: 24px 0 16px 0;
  justify-content: space-between;
}
.navbar-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  min-width: 160px; /* 可根据按钮宽度微调 */
  justify-content: flex-end;
}
/* .nav-logo-placeholder {
  width: 32px;
  height: 32px;
  background: #222;
  border-radius: 6px;
  margin-right: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
} */
/* .nav-logo-placeholder::after {
  content: "F";
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  font-family: Arial, sans-serif;
} */
.nav-menu {
  display: flex;
  gap: 32px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-menu a {
  text-decoration: none;
  color: inherit;
}

.nav-menu li {
  cursor: pointer;
  font-size: 1rem;
  color: #222;
  transition: color 0.2s;
  font-weight: 500;
}
.nav-menu li.active {
  color: #222;
  font-weight: 700;
}
.nav-menu .active {
  color: #222;
  font-weight: 700;
}
.nav-menu li:not(.active) {
  color: #64748b;
  font-weight: 500;
}

/* 汉堡按钮，默认隐藏，移动端显示 */
.nav-hamburger {
  display: none;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
}
.hamburger-icon {
  width: 24px;
  height: 2px;
  background: #222;
  position: relative;
  display: block;
}
.hamburger-icon::before,
.hamburger-icon::after {
  content: "";
  position: absolute;
  left: 0;
  width: 24px;
  height: 2px;
  background: #222;
  transition: 0.2s;
}
.hamburger-icon::before {
  top: -8px;
}
.hamburger-icon::after {
  top: 8px;
}

/* 移动端抽屉菜单 */
.nav-drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
}
.drawer-top-panel {
  width: 100vw;
  min-height: 0;
  height: auto;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  animation: drawerDown 0.2s;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  max-height: 70vh;
}
@keyframes drawerDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
  padding-left: 16px;
}
.drawer-close {
  font-size: 2rem;
  cursor: pointer;
  color: #888;
  user-select: none;
}
.drawer-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start; /* 顶部对齐 */
  list-style: none;
  padding: 0 0 0 32px;
  margin: 0;
  padding-left: 16px;
}
.drawer-menu li {
  margin: 10px 0;
}
.drawer-menu a {
  font-size: 1.1rem;
  font-weight: 500;
  color: #888;
  text-decoration: none;
  transition: color 0.2s;
}
/* .drawer-menu .active,
.drawer-menu a.active {
  color: #1abc9c;
  text-decoration: underline;
} */

/* 激活状态：黑色 */
.drawer-menu .active,
.drawer-menu a.active {
  color: #222;
  font-weight: 700;
  text-decoration: none; /* 去下划线 */
}
.drawer-mask {
  flex: 1;
  width: 100vw;
  background: rgba(0, 0, 0, 0.18); /* 半透明遮罩 */
  cursor: pointer;
}
.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.2s;
}
.drawer-fade-enter-from,
.drawer-fade-leave-to {
  opacity: 0;
}

.nav-logo-img {
  width: 100px; /* 更大 */
  height: 100px;
  margin-right: 32px;
  object-fit: contain;
  display: block;
}

/* 响应式：移动端显示汉堡，隐藏横向菜单 */
@media (max-width: 700px) {
  .nav-menu,
  .navbar-actions {
    display: none !important;
  }
  .nav-hamburger {
    display: flex !important;
  }
  .navbar-content {
    justify-content: flex-start;
  }
  .mobile-actions {
    display: flex !important;
    align-items: center;
    margin-right: 8px;
  }
  .connect-button {
    margin: 0 0 0 0;
    margin-right: 8px;
  }
}
@media (min-width: 701px) {
  .nav-hamburger,
  .nav-drawer {
    display: none !important;
  }
}

/* 默认只显示桌面actions，隐藏mobile-actions */
.desktop-actions {
  display: flex;
}
.mobile-actions {
  display: none;
}
.navbar-right {
  display: none;
  align-items: center;
}

/* 移动端只显示mobile-actions，隐藏桌面actions */
@media (max-width: 700px) {
  .nav-menu,
  .desktop-actions {
    display: none !important;
  }
  .navbar-right {
    display: flex !important;
    align-items: center;
    margin-left: auto;
  }
  .mobile-actions {
    display: flex !important;
    align-items: center;
    margin-right: 8px;
  }
  .nav-hamburger {
    display: flex !important;
  }
  .connect-button {
    margin: 0;
    margin-right: 8px;
  }
  .navbar-content {
    justify-content: space-between; /* 保证两端对齐 */
  }
}
@media (min-width: 701px) {
  .navbar-right {
    display: none !important;
  }
}
</style>
